import './styles/LanguageDetection.scss';
import LanguageDetection from './js/LanguageDetection';

export default LanguageDetection;
